import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../abstract/api.service';
import { LookupUserOrganization } from '../response-models/lookup-user-organization.model';
import { LookupUserResult } from '../response-models/lookup-user-result.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, idString, nullableString } from '../utils/wire-value-utils';

/** GET /admin/lookup-user?email= (hub `admin-users-organizations-controller.ts`): a user and their organizations. */
@Injectable({ providedIn: 'root' })
export class LookupUserService extends ApiService {
  constructor() {
    super('admin/lookup-user');
  }

  /** Fails with a 404 `ApiError` when no user has that email. */
  lookupUser(email: string): Observable<LookupUserResult> {
    return this.request('GET', { query: { email: email.trim() } }, toLookupResult);
  }
}

function toLookupResult(data: unknown): LookupUserResult {
  const source = isRecord(data) ? data : {};
  const organizations = Array.isArray(source['organizations']) ? source['organizations'].map(toLookupOrganization) : [];
  return {
    id: idString(source['id']),
    email: nullableString(source['email']) ?? null,
    firstName: nullableString(source['firstName']) ?? null,
    lastName: nullableString(source['lastName']) ?? null,
    hasFirebaseAccount: source['hasFirebaseAccount'] === true,
    organizations,
  };
}

function toLookupOrganization(item: unknown): LookupUserOrganization {
  const source = isRecord(item) ? item : {};
  return { id: idString(source['id']), name: nullableString(source['name']) ?? '', role: countOrZero(source['role']) };
}
